import gql from 'graphql-tag';

export const SAVE_ESTATE_IN_FAVORITES = gql`
  mutation propertyFav($propertyId: Int!) {
    propertyFav(propertyId: $propertyId)
  }
`;
export const UNSAVE_ESTATE_IN_FAVORITES = gql`
  mutation propertyUnfav($propertyId: Int!) {
    propertyUnfav(propertyId: $propertyId)
  }
`;
